import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';

export default class DeliveryInstructionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryInstructionId  = '';
		this.deliveryInstructionDiNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.qtyDelivery = '';
		this.deliveryOrderDetailId  = '';
		this.deliveryOrderDetailPoNumber = '';
		this.isNeedRegenerateDc = false;
		this.needRepackQty = '';
		this.qtyActualSupply = '';
		this.qtyOutstanding = '';
		this.deliveryInstructionStatusId  = '';
		this.deliveryInstructionStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryInstructionId : '0',
			deliveryInstructionDiNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			qtyDelivery : '0',
			deliveryOrderDetailId : '0',
			deliveryOrderDetailPoNumber : '0',
			isNeedRegenerateDc : '0',
			needRepackQty : '0',
			qtyActualSupply : '0',
			qtyOutstanding : '0',
			deliveryInstructionStatusId : '0',
			deliveryInstructionStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}